export default "__VITE_ASSET__DMgV_Qc$__"